import ClassCategoryBulkConfirmModal from '@/features/profile/classes/ClassCategoryBulkConfirmModal';
import { useClassCategoryBulkMutation } from '@/features/class/useClassCategoryMutations';
import { useProfileClassOrganizationStore } from '@/features/profile/classes/profileClassOrganizationStore';
import { useAuthStore } from '@/store/authStore';
import { useState } from 'react';

export default function ClassCategoryBulkConfirmModalHost() {
  const pendingBulkAction = useProfileClassOrganizationStore((state) => state.pendingBulkAction);
  const closeCategoryBulkAction = useProfileClassOrganizationStore(
    (state) => state.closeCategoryBulkAction,
  );
  const confirmCategoryBulkAction = useProfileClassOrganizationStore(
    (state) => state.confirmCategoryBulkAction,
  );
  const mutation = useClassCategoryBulkMutation();
  const setRawUser = useAuthStore((state) => state.setRawUser);
  const [error, setError] = useState<string>();

  if (!pendingBulkAction) {
    return null;
  }

  return (
    <ClassCategoryBulkConfirmModal
      categoryId={pendingBulkAction.categoryId}
      action={pendingBulkAction.action}
      onClose={closeCategoryBulkAction}
      isPending={mutation.isPending}
      error={error}
      onConfirm={async () => {
        setError(undefined);
        try {
          await mutation.mutateAsync(pendingBulkAction);
          const rawUser = useAuthStore.getState().rawUser;
          const groups = rawUser?.boardWithCategory;
          if (Array.isArray(groups)) {
            setRawUser({
              ...rawUser,
              boardWithCategory: groups.filter((group) => {
                const id = (group as { categoryId?: unknown })?.categoryId;
                return String(id) !== pendingBulkAction.categoryId;
              }),
            });
          }
          confirmCategoryBulkAction();
        } catch (cause) {
          setError(cause instanceof Error ? cause.message : 'Could not complete this action.');
        }
      }}
    />
  );
}
